import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useContext } from "react";
import Contexto from "../context/Contexto";
import { useLocation } from "react-router-dom";
import MercadoPagoLite from "../components/MercadoPagoLite";
import "../assets/css/Carrito.css";
import Tarjetas from "../assets/statics/tarjetas.png";
import "../assets/css/Home.css";
import "../assets/css/Login.css";
import Carita from "../assets/CCstatics/avatar4.png";
import {
  PayPalScriptProvider,
  PayPalButtons,
  BraintreePayPalButtons,
} from "@paypal/react-paypal-js";
<div class="fc-title">DISPONIBLE</div>;
function Planes(props) {
  const {
    seteos,

    cliente,
    loguearUsuario,
    mandarMensajes,
    dameMiCurso,
    productos,
  } = useContext(Contexto);
  const location = useLocation();
  const [totalPesos, setTotalPesos] = useState(0);
  const [totalDolar, setTotalDolar] = useState(0);
  const [totalBruto, setTotalBruto] = useState(0);
  const [descuentos, setDescuentos] = useState(0);
  const [armadoProductos, setArmadoProductos] = useState(0);
  const [producto, setProducto] = useState("");
  const [regalado, setRegalado] = useState("");
  const [anual, setAnual] = useState("");
  const [semestral, setSemestral] = useState("");

  useEffect(() => {
    let path = location.pathname.split("/");
    let productoSeleccionado = productos.filter(
      (ite) => ite.url === `/${path[2]}`
    );
    setProducto(productoSeleccionado);
    var totaloco = 0;

    if (productoSeleccionado[0]) {
      if (path[2] == "club-mensual") {
        totaloco = productoSeleccionado[0].precio;
      } else {
        totaloco =
          productoSeleccionado[0].precio - productoSeleccionado[0].descuento;
      }
      setTotalPesos(totaloco);
    }
    if (productoSeleccionado[0]) {
      setTotalDolar(productoSeleccionado[0].dolar);
    }
    if (seteos && seteos.hasOwnProperty("sueltos")) {
      setSemestral(seteos.sueltos.semestral);
      setAnual(seteos.sueltos.anual);
    }
  }, [productos, seteos]);

  useEffect(() => {
    console.log("cliente:", cliente);
    if (producto[0]) {
      setProductou(producto[0].url.slice(1));
    }
  }, [totalPesos]);
  const [palabraClave, setPalabraClave] = useState(0);
  /*eslint-disable */
  let totalAntesDescuento = 0;
  /*eslint-disable */
  let isOferta = false;
  let total = 0;
  let ahorro = 0;

  //Si no hay nada en carrito, me rajo al home
  const navigate = useNavigate();

  const handleCheck = (e) => {
    setRegalado(e.target.checked);
    if (e.target.checked) {
      mandarMensajes("Que bien vas a regalar esta compra.");
    } else {
      mandarMensajes("Uy, te arrepentiste... bueh");
    }
  };

  let dameCursos = () => {
    dameMiCurso({ pibe: cliente.uid, cursin: [productou] });
    mandarMensajes(
      `Gracias por tu compra! te agregué ${productou}, podés verlos en tus cursos ya mismo.`
    );
  };

  return (
    <>
      <section className="home ">
        <div className="soporteLogin">
          <div className="login">
            <div className="login__wrapper centradoCompra">
              <br />
              <br />
              <img className="caritaCompra" src={Carita} alt="" />
              <p className="titFelicitaciones">Elegí una opción:</p>
              <div className="suscripciones">
                <Link to="/comprar/club-mensual/">> Suscripción mensual</Link>{" "}
                <br />
                {/* <Link to={semestral}>> Abono por 6 meses</Link> <br />
                <Link to={anual}>> Abono por 1 año </Link> */}
                <Link to={"/comprar/club-semestral"}>> Abono por 6 meses</Link>{" "}
                <br />
                <Link to={"/comprar/club-anual"}>> Abono por 1 año </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Planes;
